<template>
  <div style="margin-bottom: 10px">
    <el-card class="box-card" style="margin-top: 3px">
      <div slot="header" class="clearfix">
        <span>累充进度奖励</span>
        <el-button
          style="float: right"
          type="primary"
          icon="el-icon-plus"
          @click="openDialog(true, null)"
          >新增累充进度奖励</el-button
        >
      </div>
      <el-table
        :data="data"
        border
        size="small"
        style="width: 631px; margin-top: 10px"
      >
        <el-table-column
          prop="stage"
          label="阶段"
          align="center"
          width="80"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.stage }}
          </template>
        </el-table-column>
        <el-table-column
          prop="condition"
          label="金额（元）"
          align="center"
          width="100"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.condition }}
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="label"
          label="奖励"
          align="center"
          width="350"
        >
          <template slot-scope="scope">
            <ShowItems :items="scope.row.reward" />
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" align="center" width="100">
          <template slot-scope="scope">
            <span
              class="link-button"
              style="color: red"
              @click="remove(scope.$index)"
              >删除</span
            >
            <span
              class="link-button"
              @click="openDialog(false, scope.row, scope.$index)"
              >编辑</span
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import ShowItems from "./components/ShowItems";
export default {
  data() {
    return {
      data: [],
    };
  },
  components: {
    ShowItems,
  },

  watch: {
    data: {
      async handler() {
        await this.updatedParam();
      },
      deep: true,
    },
  },

  async created() {
    await this.loadConfig();
    if (this.parameter) {
      this.data = JSON.parse(this.parameter);
    }
  },

  props: {
    parameter: "",
  },

  methods: {
    async loadConfig() {},
    async openDialog(isCreated, entry, index) {
      let that = this;
      this.$dialogutil.open("EditCumulativeRechargeOfLimitTimeDialog", {
        closedCallback: async (param) => {
          if (param != null) {
            if (isCreated) {
              that.data.push(param);
            } else {
              this.$set(that.data, index, param);
            }

            this.data.sort((x, y) => {
              return x.stage - y.stage;
            });

            await this.updatedParam();
          }
        },
        data: { isCreated, entry },
      });
    },
    async remove(index) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除阶段：${this.data[index].stage}的配置？`);
        this.data.tasks.splice(index, 1);

        await this.updatedParam();
      } catch (error) {}
    },

    async updatedParam() {
      this.$emit("updated", JSON.stringify(this.data), async () => {
        return;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.link-button {
  padding-left: 5px;
  padding-right: 5px;
  color: rgb(37, 148, 240);

  cursor: pointer;
}

::v-deep .el-table__row td {
  padding: 0px 0;
}

.el-table .cell.el-tooltip {
  white-space: normal;
}
</style>